import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import iziToast from 'izitoast' // https://github.com/dolce/iziToast
import 'izitoast/dist/css/iziToast.min.css'

function toast ({ title, message, type, timeout, cb }) {
  if (type === VueNotifications.types.warn) type = 'warning'
  return iziToast[type]({ title, message, timeout })
}

function question ({ message, ok, cancel }) {
  const options = {
    close: false,
    displayMode: 'once',
    timeout: false,
    message: message,
    title: '',
    // backgroundColor: '#1867c0',//'#fb8c00',
    position: 'bottomRight',
    icon: 'mdi mdi-comment-question-outline',
    buttons: [
      ['<button><b>YES</b></button>', function (instance, toast) {
        if (ok) {
          ok()
        }
        instance.hide({ transitionOut: 'fadeOut' }, toast, 'button')
      }, true],
      ['<button>NO</button>', function (instance, toast) {
        if (cancel) {
          cancel()
        }
        instance.hide({ transitionOut: 'fadeOut' }, toast, 'button')
      }]
    ]
  }
  return iziToast['question'](options)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

const $notify = {}

for (let type in options) {
  $notify[type] = (title, message = '', { timeout = 3000 } = {}) => {
    toast({ type, title, message, timeout })
  }
}
$notify['question'] = (message = '', ok, cancel) => {
  question({ message, ok, cancel })
}

Vue.use(VueNotifications, options)
Vue.prototype.$notify = $notify
